import React, { Component } from 'react'
import { defaultPaperPadding, highestCampaignPriority, lowestCampaignPriority, maxAudiosPerCampaign, maxSizeAudioCampaign, url_endpoint } from '../../../config'
import checkLogin from '../../Utils/checkLogin'
import { Button, CardHeader, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, InputAdornment, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core'
import LoaderSpinner from '../../../componentes/LoaderSpinner'
import palette from '../../../theme/palette'
import request from 'superagent'
import authHeader from '../../Utils/AuthHeader'
import { Add, Delete, Publish } from '@material-ui/icons'
import { v4 as uuid } from 'uuid';
import DateRangePickers from '../Dashboard/components/DateRangePickers'
import { DateSelectorCard } from './components/DateSelectorCard'
import { SelectableCard } from './components/SelectableCard'
import playOnStartIcon from '../../../images/icons/play_on_start_icon.svg'
import playOnMiddleIcon from '../../../images/icons/play_on_middle_icon.svg'
import playOnEndIcon from '../../../images/icons/play_on_end_icon.svg'
import randomIcon from '../../../images/icons/random_arrow_icon.svg'
import moment from 'moment'
import InfoTooltip from '../components/InfoTooltip'

class EditCampaign extends Component {
    constructor(props) {
        super(props)

        this.props.setTitulo('Editar Campanha')

        this.state = {
            client: null,
            loading: true,
            title: '',
            active: true,
            priority: lowestCampaignPriority,
            // Audio format: {id, fileName (if already exists), localId, file, title, active, link}
            audios: [],
            removedAudios: [],
            genericDialogOpen: false,
            genericDialogTitle: '',
            genericDialogMessage: '',
            genericDialogAdditionalCallback: async () => { },
            campaignId: null,
            automaticToggleActive: false,
            startDate: null,
            endDate: null,
            playOnRandom: false,
            playOnStart: false,
            playOnMiddle: false,
            playOnEnd: false,
        }
    }

    async componentDidMount() {
        const clientData = await checkLogin(false)

        await this.getCampaign()

        this.setState({ loading: false, client: clientData })
    }

    openDialog(title, message, additionalCallback) {
        this.setState({ genericDialogOpen: true, genericDialogTitle: title, genericDialogMessage: message, genericDialogAdditionalCallback: additionalCallback })
    }

    linkIsValid(link) {
        if (!link.includes('https')) {
            return false
        }

        return true
    }

    titleIsValid(title) {
        if (title == '') {
            return false
        }

        return true
    }

    priorityFieldIsValid() {
        const priority = this.state.priority
        if (typeof (priority) != 'number') {
            console.log("typeof (priority) != 'number'")
            return false;
        }
        if (priority < lowestCampaignPriority) {
            console.log("priority < lowestCampaignPriority")
            return false
        }
        if (priority > highestCampaignPriority) {
            console.log("priority > highestCampaignPriority")
            return false;
        }

        return true
    }

    audioFileIsValid(audio, showDialog) {
        const file = audio.file

        if (audio.id != null && (file == null || file == undefined)) {
            return true;
        }

        if (file instanceof File == false) {
            if (showDialog) {
                this.openDialog('Arquivo não encontrado', `Não foi possível encontrar o arquivo para o áudio ${audio.title}`)
            }
            return false
        }

        if (!file.type.includes('audio/')) {
            if (showDialog) {
                this.openDialog('Erro ao ler arquivo', `Não foi possível ler o arquivo para o áudio ${audio.title}`)
            }
            return false
        }

        const inLimit = this.fileSizeInLimit(file, maxSizeAudioCampaign)

        if (!inLimit) {
            if (showDialog) {
                this.openDialog('Arquivo muito grande', `O arquivo do áudio ${audio.title} ultrapassa o limite de ${maxSizeAudioCampaign}mb`)
            }
            return false
        }

        // TODO: check duration too

        return true
    }

    audiosAreValid() {
        for (let i = 0; i < this.state.audios.length; i++) {
            const audio = this.state.audios.at(i)
            if (!this.titleIsValid(audio.title)) {
                return false;
            }
            if (!this.linkIsValid(audio.link)) {
                return false
            }
            if (!this.audioFileIsValid(audio)) {
                return false
            }
        }

        return true
    }

    formIsValid() {
        const mainTitleValid = this.titleIsValid(this.state.title)
        const priorityValid = this.priorityFieldIsValid()
        const audiosAreValid = this.audiosAreValid()

        // Case the campaign is active, it has to have at least one valid audio
        if (this.state.active == true && (this.state.audios.find((a) => a.active == true) == undefined)) {
            return false
        }

        // Case automatic toggle active, start and end dates are required
        if (this.state.automaticToggleActive && (this.state.startDate == null || this.state.endDate == null)) {
            return false
        }

        // Case the ad position isn't random, need to be in a position
        if (!this.state.playOnRandom && (this.state.playOnStart == false && this.state.playOnMiddle == false && this.state.playOnEnd == false)) {
            return false
        }

        return mainTitleValid && priorityValid && audiosAreValid
    }

    fileSizeInLimit(file, limit) {
        const fileSizeInMB = file.size / 1000000

        return fileSizeInMB < limit
    }

    buildAudioRow(audio) {
        console.log(audio)
        return <TableRow>
            <TableCell align="left" style={{ color: 'grey' }}>
                <TextField
                    error={!this.titleIsValid(audio.title)}
                    onChange={(e) => {
                        audio.title = e.target.value
                        this.setState({})
                    }}
                    value={audio.title}
                    required
                    label="Título"
                    variant='filled'
                    style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                    InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                />
            </TableCell>
            <TableCell align="left" style={{ color: 'grey' }}>
                <TextField
                    error={!this.linkIsValid(audio.link)}
                    onChange={(e) => {
                        audio.link = e.target.value
                        this.setState({})
                    }}
                    value={audio.link}
                    required
                    label="Link de ação"
                    variant='filled'
                    placeholder='https://exemplo.com'
                    style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                    InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                />
            </TableCell>
            <TableCell align="left" style={{ color: 'grey' }}>
                <label htmlFor={`audioFile${audio.localId}`}>
                    <div style={{ width: '220px', cursor: 'pointer', display: 'flex', alignItems: 'center', border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey', padding: '15px', height: '55.63px', color: palette.primary.main }}>
                        <Publish></Publish>
                        <span style={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginLeft: '5px', textDecoration: 'underline', textUnderlineOffset: '2px', fontSize: '14px' }}>{audio.file != null ? audio.file.name : audio.fileName ?? 'Fazer Upload do Arquivo'}</span>
                    </div>
                    <div>
                        <input
                            accept="audio/mp3"
                            id={`audioFile${audio.localId}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={async (evt) => {
                                if (evt.target.files.length == 0) {
                                    audio.file = null
                                    this.setState({})
                                    return
                                }

                                const file = evt.target.files[0]

                                audio.file = file

                                const validFile = this.audioFileIsValid(audio, true)

                                if (!validFile) {
                                    audio.file = null
                                    return
                                }

                                audio.file = file
                                this.setState({})
                            }}
                        />
                    </div>
                </label>
            </TableCell>
            <TableCell align="left" style={{ color: 'grey' }}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={audio.active}
                            onChange={(e) => {
                                audio.active = e.target.checked
                                this.setState({})
                            }}
                            name="active"
                            color="primary"
                        />
                    }
                    label={`Áudio ${audio.active ? 'ativo' : 'inativo'}`}
                />
            </TableCell>
            <TableCell align="left" style={{ color: 'grey' }}>
                <Delete color='error' style={{ cursor: 'pointer' }} onClick={() => {
                    const newAudiosList = this.state.audios.filter((a) => a != audio)
                    this.setState({ audios: newAudiosList })
                }}></Delete>
            </TableCell>
        </TableRow>
    }

    async getCampaign() {
        try {
            const campaignId = this.props.match.params.id

            const resGetCampaign = await request.get(`${url_endpoint}/adCampaign/complete/${campaignId}`).set(authHeader())

            const campaignData = resGetCampaign.body

            let audios = []

            for (let i = 0; i < campaignData.CampaignAudios.length; i++) {
                const audio = campaignData.CampaignAudios[i];
                audios.push({
                    id: audio.id,
                    localId: uuid(),
                    file: null,
                    fileName: audio.audioName,
                    title: audio.title,
                    active: audio.active,
                    link: audio.adLink,
                    audioPath: audio.audioPath,
                })
            }

            this.setState({
                title: campaignData.title,
                active: campaignData.active,
                priority: campaignData.priority,
                audios: audios,
                campaignId: campaignId,
                automaticToggleActive: campaignData.automaticToggleActive,
                startDate: campaignData.startDate,
                endDate: campaignData.endDate,
                playOnRandom: campaignData.playOnRandom,
                playOnStart: campaignData.playOnStart,
                playOnMiddle: campaignData.playOnMiddle,
                playOnEnd: campaignData.playOnEnd,
            })
        } catch (e) {
            console.log(e)
            this.openDialog('Erro ao buscar os dados', e.response.text)
        }
    }

    async editCampaign() {
        try {
            this.setState({ loading: true })

            const mountReq = request.put(url_endpoint + 'adCampaign/')
                .set(authHeader())

            let audiosToSend = []

            for (let i = 0; i < this.state.audios.length; i++) {
                const audio = this.state.audios.at(i)

                const audioFileId = audio.id != null ? audio.audioPath.split('/').at(-1).replace('.mp3', '') : uuid()

                audio.audioFileId = audioFileId
                audiosToSend.push(audio)

                if (audio.id != null && (audio.file == null || audio.file == undefined)) {
                    continue
                }

                mountReq.attach(audioFileId, audio.file)
            }

            mountReq.field('campaignId', this.state.campaignId)
            mountReq.field('title', this.state.title)
            mountReq.field('active', this.state.active)
            mountReq.field('priority', this.state.priority)
            mountReq.field('audios', JSON.stringify(audiosToSend))
            mountReq.field('removedAudios', JSON.stringify(this.state.removedAudios))
            mountReq.field('automaticToggleActive', this.state.automaticToggleActive)
            mountReq.field('playOnRandom', this.state.playOnRandom)
            mountReq.field('playOnStart', this.state.playOnStart)
            mountReq.field('playOnMiddle', this.state.playOnMiddle)
            mountReq.field('playOnEnd', this.state.playOnEnd)

            if (this.state.automaticToggleActive) {
                mountReq.field('startDate', this.state.startDate)
                mountReq.field('endDate', this.state.endDate)
            }

            const res = await mountReq

            this.setState({ loading: false })

            this.openDialog('Editada com sucesso', 'A campanha foi editada com sucesso', () => {
                window.history.back()
            })
        } catch (e) {
            this.setState({ loading: false })
            this.openDialog('Erro ao editar campanha', e.response.text)
        }
    }

    changerangedata = async (startDate, endDate) => {
        this.setState({ startDate: startDate, endDate: endDate })
    }

    formatDateToPicker(date) {
        let momentDate = moment(date)
        momentDate.add(3, 'hours')
        return momentDate.format('DD/MM/YYYY')
    }

    render() {
        return <>
            {this.state.loading && <LoaderSpinner></LoaderSpinner>}
            <Dialog
                open={this.state.genericDialogOpen}
                onClose={async () => {
                    if (this.state.genericDialogAdditionalCallback != null) {
                        await this.state.genericDialogAdditionalCallback()
                    }
                    this.setState({ genericDialogOpen: false })
                }}
            >
                <DialogTitle>
                    <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.genericDialogTitle}</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span style={{ fontSize: '14px' }}>{this.state.genericDialogMessage}</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <span onClick={async () => {
                        if (this.state.genericDialogAdditionalCallback != null) {
                            await this.state.genericDialogAdditionalCallback()
                        }
                        this.setState({ genericDialogOpen: false })
                    }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                        {"OK"}
                    </span>
                </DialogActions>
            </Dialog>
            <div style={{ marginBottom: '25px' }}>
                <h2 style={{ marginBottom: '5px' }}>Editar Campanha</h2>
                <h3 style={{ color: 'grey' }}>Cadastre novos áudios para veiculação do seu blog/portal.</h3>
            </div>
            <form style={{ display: 'flex', flexDirection: 'column', gap: '25px', flexWrap: 'wrap', alignItems: 'flex-start' }} autoComplete='off' onSubmit={(e) => {
                e.preventDefault()
            }}>
                <TextField
                    fullWidth
                    error={!this.titleIsValid(this.state.title)}
                    onChange={(e) => {
                        this.setState({ title: e.target.value })
                    }}
                    value={this.state.title}
                    required
                    label="Título"
                    variant='filled'
                    style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                    InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                />
                <TextField
                    fullWidth
                    error={!this.priorityFieldIsValid()}
                    onChange={(e) => {
                        this.setState({ priority: isNaN(parseInt(e.target.value)) ? '' : parseInt(e.target.value) })
                    }}
                    value={this.state.priority}
                    inputProps={{ min: lowestCampaignPriority, max: highestCampaignPriority }}
                    required
                    label={`Prioridade (${lowestCampaignPriority} - ${highestCampaignPriority})`}
                    type="number"
                    variant='filled'
                    style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                    InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' }, endAdornment: <InputAdornment position='end' style={{ marginTop: '5px' }}><InfoTooltip text='Quanto maior a prioridade, maior será a frequência que a campanha será sorteada'></InfoTooltip></InputAdornment> }}
                />
                <divider style={{ display: 'flex', height: '2px', width: '100%', backgroundColor: 'lightgrey' }}></divider>
                <div style={{ marginBottom: '10px' }}>
                    <h2 style={{ marginBottom: '5px' }}>Programar</h2>
                    <h3 style={{ color: 'grey' }}>Defina o período em que a campanha vai ser veiculada.</h3>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    <FormControlLabel
                        style={{ alignSelf: 'flex-start' }}
                        control={
                            <Switch
                                checked={this.state.automaticToggleActive}
                                onChange={(e) => this.setState({ automaticToggleActive: e.target.checked, startDate: null, endDate: null })}
                                name="automaticToggleActive"
                                color="primary"
                            />
                        }
                        label={<span>Campanha com período definido <span style={{ color: 'grey', marginLeft: '5px' }}>Será ativada e inativada no período definido.</span></span>}
                    />
                    {this.state.automaticToggleActive &&
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                            <DateSelectorCard onChange={(date) => {
                                this.setState({ startDate: date })
                            }} label="Data de Início" value={this.state.startDate != null ? this.formatDateToPicker(this.state.startDate) : ''}></DateSelectorCard>
                            <DateSelectorCard onChange={(date) => {
                                this.setState({ endDate: date })
                            }} label="Término" value={this.state.endDate != null ? this.formatDateToPicker(this.state.endDate) : ''}></DateSelectorCard>
                        </div>
                    }
                    <FormControlLabel
                        style={{ alignSelf: 'flex-start' }}
                        control={
                            <Switch
                                checked={this.state.active}
                                onChange={(e) => this.setState({ active: e.target.checked })}
                                name="active"
                                color="primary"
                            />
                        }
                        label="Campanha ativa"
                    />
                </div>
                <divider style={{ display: 'flex', height: '2px', width: '100%', backgroundColor: 'lightgrey' }}></divider>
                <div>
                    <div style={{ marginBottom: '10px' }}>
                        <h2 style={{ marginBottom: '5px' }}>Posição dos anúncios</h2>
                        <h3 style={{ color: 'grey' }}>Defina em que posições do seu áudio o anúncio vai aparecer.</h3>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                        <SelectableCard icon={playOnStartIcon} label="Reproduzir no início" description='O anúncio tocará logo antes do seu áudio.' selected={this.state.playOnStart} onChange={(val) => this.setState({ playOnStart: val, playOnRandom: false })} ></SelectableCard>
                        <SelectableCard icon={playOnMiddleIcon} label="Reproduzir no meio" description='O anúncio tocará na metade do seu áudio.' selected={this.state.playOnMiddle} onChange={(val) => this.setState({ playOnMiddle: val, playOnRandom: false })} ></SelectableCard>
                        <SelectableCard icon={playOnEndIcon} label="Reproduzir no final" description='O anúncio tocará nos últimos segundos do seu áudio.' selected={this.state.playOnEnd} onChange={(val) => this.setState({ playOnEnd: val, playOnRandom: false })} ></SelectableCard>
                        <SelectableCard icon={randomIcon} label="Aleatório" description='O anúncio tocará aleatóriamente em uma ou mais posições.' selected={this.state.playOnRandom} onChange={(val) => this.setState({ playOnStart: false, playOnMiddle: false, playOnEnd: false, playOnRandom: val })} ></SelectableCard>
                    </div>
                </div>
            </form>
            <divider style={{ display: 'flex', height: '2px', width: '100%', backgroundColor: 'lightgrey', margin: '25px 0' }}></divider>
            <div style={{ marginBottom: '10px' }}>
                <h2 style={{ marginBottom: '5px' }}>Áudios da Campanha</h2>
                <h3 style={{ color: 'grey' }}>Cadastre até {maxAudiosPerCampaign} áudios por campanha, com título e link de ação (CTA).</h3>
            </div>
            <Paper style={{ display: 'flex', flexDirection: 'column', gap: '25px', padding: defaultPaperPadding }}>
                {this.state.audios.length > 0 &&
                    <TableContainer>
                        <Table>
                            <TableHead style={{ backgroundColor: 'transparent' }}>
                                <TableRow>
                                    <TableCell style={{ color: 'grey' }} align="left">Título</TableCell>
                                    <TableCell style={{ color: 'grey' }} align="left">Link da Ação</TableCell>
                                    <TableCell style={{ color: 'grey' }} align="left">Upload do Áudio</TableCell>
                                    <TableCell style={{ color: 'grey' }} align="left">Status</TableCell>
                                    <TableCell style={{ color: 'grey' }} align="left"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.audios.map((a) => this.buildAudioRow(a))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                {this.state.audios.length < maxAudiosPerCampaign &&
                    <div onClick={() => {
                        const newAudio = { localId: uuid(), file: null, title: `Áudio ${this.state.audios.length + 1}`, active: true, link: '' }
                        const newAudiosList = [...this.state.audios, newAudio]
                        this.setState({ audios: newAudiosList })
                    }} style={{ display: 'flex', justifyContent: 'center', color: 'grey', cursor: 'pointer', border: '1px dashed grey', padding: '10px' }}>
                        <Add></Add>
                    </div>
                }
            </Paper>
            <Button disabled={!this.formIsValid()} style={{ marginTop: '25px' }} variant='contained' color='primary' onClick={() => this.editCampaign()}>Editar</Button>
        </>
    }
}

export default EditCampaign